import React from "react";

const AllHeading = ({ children }) => {
  return (
    <h3
      style={{
        fontSize: "17px",
        fontWeight: "600",
        color: "#2c3e50",
        display: "inline-block",
      }}
    >
      {children}
    </h3>
  );
};

export default AllHeading;
